import { useEffect, useRef } from 'react';
import { useWizard } from '../../../wizard/hooks/useWizard';
import { PipelineStorageKeys } from '../../constants/storage-keys';
import { Integration } from '../../../shared/interfaces/integration';
import { WizardVersion } from '../../../wizard/interfaces/wizard-step';
import { useEditPipelineStateMachine } from '../edit-pipeline-state-machine/hooks/useEditPipelineStateMachine';
import { EDIT_PIPELINE_STEP_GROUPS } from '../edit-pipeline-state-machine/constants/edit-pipeline-step-groups';

export function useEditPipelineWizard({ integration }: { integration: Integration }) {
  const initialCache = useRef(
    new Map().set(PipelineStorageKeys.EDIT_PIPELINE, {
      steps: [],
      data: { integration },
      version: WizardVersion.V2
    })
  );

  const {
    wizardState,
    createWizard,
    stepTracker,
    currentStep,
    stepTreeSnapshot,
    stepGroups,
    selectStepGroup,
    currentStepFooterProps,
    onBackClick,
    onCancelClick
  } = useWizard({
    initialCache: initialCache.current,
    onComplete: () => {},
    cancelUrl: `../job-history`,
    isCancelUrlPathRelative: true
  });

  const stateMachine = useEditPipelineStateMachine();

  useEffect(() => {
    createWizard({
      stepsHeader: EDIT_PIPELINE_STEP_GROUPS,
      options: {
        trackingOptions: {
          storageKey: PipelineStorageKeys.EDIT_PIPELINE
        }
      },
      stateMachine
    });
  }, []);

  return {
    stateMachine,
    wizardState,
    currentStep,
    stepGroups,
    stepTreeSnapshot,
    stepTracker,
    selectStepGroup,
    createWizard,
    onBackClick,
    onCancelClick,
    currentStepFooterProps
  };
}
